import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  Company,
  Deploy,
  PaginateDeploy,
  Profile,
} from '@cyborg-monorepo/hunter/common';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

type DeployStatus = 'notDeployed' | 'staged' | 'deployed' | 'outdated';

@Injectable({
  providedIn: 'root',
})
export class CompanyService {
  constructor(private httpClient: HttpClient) {}

  public getCompanyDetails = (): Observable<Company> => {
    return this.httpClient.get<Company>(`${environment.api}/company`);
  };

  public getStagedDeploys = (
    size: number,
    page: number,
  ): Observable<PaginateDeploy> => {
    return this.httpClient.get<PaginateDeploy>(
      `${environment.api}/company/deploys/staged?size=${size}&page=${page}`,
    );
  };

  public getDeployedDeploys = (
    size: number,
    page: number,
  ): Observable<PaginateDeploy> => {
    return this.httpClient.get<PaginateDeploy>(
      `${environment.api}/company/deploys/deployed?size=${size}&page=${page}`,
    );
  };

  public getOutdatedDeploys = (
    size: number,
    page: number,
  ): Observable<PaginateDeploy> => {
    return this.httpClient.get<PaginateDeploy>(
      `${environment.api}/company/deploys/outdated?size=${size}&page=${page}`,
    );
  };

  public getDeployStatus = (
    huntPackageUUID: string,
  ): Observable<Deploy & { status: DeployStatus }> => {
    return this.httpClient.get<Deploy & { status: DeployStatus }>(
      `${environment.api}/company/deploys/${huntPackageUUID}`,
    );
  };

  public markAsStaged = (huntPackageUUID: string): Observable<Deploy> => {
    return this.httpClient.post<Deploy>(
      `${environment.api}/company/deploys/${huntPackageUUID}/stageDeploy`,
      null,
    );
  };

  public markAsDeployed = (huntPackageUUID: string): Observable<Deploy> => {
    return this.httpClient.post<Deploy>(
      `${environment.api}/company/deploys/${huntPackageUUID}/markDeployed`,
      null,
    );
  };

  public removeDeployed = (huntPackageUUID: string): Observable<Deploy> => {
    return this.httpClient.post<Deploy>(
      `${environment.api}/company/deploys/${huntPackageUUID}/removeDeployed`,
      null,
    );
  };

  public getUsers = (): Observable<Array<Profile>> => {
    return this.httpClient.get<Array<Profile>>(
      `${environment.api}/company/users`,
    );
  };

  public reactivateCompany(): Observable<Company> {
    return this.httpClient.put<Company>(
      `${environment.api}/company/reactivate`,
      null,
    );
  }
}
